/**
 * Ce que la carte retient entre deux visites.
 *
 * Ouvrir la page d'une sortie puis revenir remontait tout a zero : on se
 * retrouvait sur la ville entiere, sans la fiche, alors qu'on venait de
 * se poser sur un point. La vue et la sortie regardee se retiennent donc
 * ici, hors des composants.
 *
 * Rien n'est ecrit sur l'appareil : fermer l'application oublie tout, et
 * c'est voulu — une vue d'hier ne veut plus rien dire. Quitter la carte
 * par la fleche oublie aussi, c'est `oublier()` qui le fait : on revient
 * alors sur le cadrage d'origine, comme la premiere fois.
 */

export interface VueRetenue {
  lat: number;
  lon: number;
  /** L'etendue en degres, pour la carte d'Apple. */
  etendue?: number;
  /** Le niveau de zoom, pour celle d'OpenStreetMap. */
  zoom?: number;
}

let vue: VueRetenue | null = null;
let sortieRegardee: string | null = null;

export function retenirLaVue(nouvelle: VueRetenue): void {
  vue = nouvelle;
}

export function vueRetenue(): VueRetenue | null {
  return vue;
}

export function retenirLaSortie(id: string | null): void {
  sortieRegardee = id;
}

export function sortieRetenue(): string | null {
  return sortieRegardee;
}

/** Quitter la carte pour de bon : la prochaine ouverture repart a neuf. */
export function oublier(): void {
  vue = null;
  sortieRegardee = null;
}
